module.exports = __webpack_public_path__ + "resources/abca638dc6f1e221196134e1275aaad0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/super-power.png
// module id = 204
// module chunks = 0